// Sales Contracts Management Permissions

export const SALES_CONTRACTS_INDEX = 275;
export const SALES_CONTRACTS_CREATE = 276;
export const SALES_CONTRACTS_UPDATE = 277;
export const SALES_CONTRACTS_CANCEL = 279;
export const SALES_CONTRACTS_SHOW = SALES_CONTRACTS_INDEX;
export const SALES_CONTRACTS_TERMINATE = 293;
export const SALES_CONTRACTS_PRINT = 1294;
// Producing the document is one capability: download is gated by the print permission.
export const SALES_CONTRACTS_DOWNLOAD = SALES_CONTRACTS_PRINT;
// No dedicated attachments endpoint: the tab reads the contract itself.
export const SALES_CONTRACTS_ATTACHMENTS_INDEX = SALES_CONTRACTS_SHOW;
export const SALES_CONTRACTS_APPROVE = 295;
export const SELL_CONTRACTS_RESTORE = 1394;
// sell_contracts.complete's approval number from the central key service.
export const SALES_CONTRACTS_COMPLETE = 1673;
